import {gql} from '@apollo/client'

/**
 * CRM-side (session-authenticated) view of the applications submitted through the
 * policytools-onboarding portal. Distinct from the portal's own public surface, which is gated
 * by the shared ONBOARDING_GRAPHQL_TOKEN and speaks the wizard's draft shape.
 */
export const GET_AGENT_ONBOARDING_APPLICATIONS = gql`
  query agentOnboardingApplications {
    agentOnboardingApplications {
      id
      referenceNumber
      submitted
      submittedAt
      created
      currentStep
      reviewStatus
      fullName
      email
      phone
      dateOfBirth
      address
      address1
      city
      zip
      usState
      hasLicense
      licenseStatus
      licenseNumber
      npn
      workAuthorizationStatus
      professionalContext
      yearsOfExperience
      previousAgency
      contractedCompanies
      invitationStatus
      invitedEmail
      uplineName
      upline {
        id
        firstName
        lastName
        avatar
        npn
      }
      organizationName
      createdUser {
        id
        email
        fullName
        npn
        isActive
      }
      documentsCount
      carrierAppointments {
        carrierId
        carrierName
        status
      }
      documents {
        documentType
        fileName
        fileUrl
        status
        uploadedAt
      }
    }
  }
`

export const GET_ONBOARDING_LIFE_CARRIERS = gql`
  query onboardingLifeCarriers {
    onboardingLifeCarriers {
      id
      name
    }
  }
`

export const GET_AGENT_ONBOARDING_APPLICATION = gql`
  query agentOnboardingApplication($id: ID!) {
    agentOnboardingApplication(id: $id) {
      id
      referenceNumber
      submitted
      submittedAt
      created
      currentStep
      reviewStatus
      internalNotes
      commissionLevel
      commissionProposalSentAt
      fullName
      email
      phone
      dateOfBirth
      address
      address1
      city
      zip
      usState
      hasLicense
      licenseStatus
      licenseNumber
      npn
      workAuthorizationStatus
      professionalContext
      yearsOfExperience
      previousAgency
      contractedCompanies
      invitationStatus
      invitedEmail
      uplineName
      upline {
        id
        firstName
        lastName
        avatar
        npn
      }
      organizationName
      createdUser {
        id
        email
        fullName
        npn
        isActive
      }
      documentsCount
      documents {
        documentType
        fileName
        fileUrl
        status
        uploadedAt
      }
      carrierAppointments {
        carrierId
        carrierName
        status
      }
    }
  }
`

/** Un upline es un agente que produce: en este CRM eso significa tener NPN. */
export const GET_ONBOARDING_UPLINE_CANDIDATES = gql`
  query onboardingUplineCandidates {
    onboardingUplineCandidates {
      id
      name
      email
      npn
      organizationName
    }
  }
`
